export const SOFTWARE_DEVELOPMENT = 'Custom software development';
export const GC_MIGRATION = 'Migration to Google Cloud';
export const CDAP = 'CDAP support';
export const BIG_DATA = 'Big data analytics, ML&AI';
export const GC_DATA_FUSION = 'Google Cloud Data Fusion';
export const SYSTEM_SUPPORT = 'System support';
export const DEVOPS_SERVICES = 'DevOps services';
export const IOT_DEVELOPMENT = 'IoT development';

export const SERVICES = [
  SOFTWARE_DEVELOPMENT,
  GC_MIGRATION,
  CDAP,
  BIG_DATA,
  GC_DATA_FUSION,
  SYSTEM_SUPPORT,
  DEVOPS_SERVICES,
  IOT_DEVELOPMENT,
];
